<template>
  <div class="box page-pre-invoice-audit-form">
    <div class="columns is-multiline">
      <div class="column">
        <sc-field label="Centros de Distribuição" prop="warehouses">
          <sc-warehouse-dropdown
            v-model="fields.warehouses"
            @selectAll="(values) => fields.warehouses = values"
            @clearFilter="() => fields.warehouses = []"
            list-user
            dropdown />
        </sc-field>
      </div>

      <div class="column">
        <sc-field label="Transportadora" prop="logistic_providers">
          <sc-logistic-provider-dropdown
            v-model="fields.logistic_providers"
            :options="enumStatus"
            @selectAll="(values) => fields.logistic_providers = values"
            @clearFilter="() => fields.logistic_providers = []"
            dropdown />
        </sc-field>
      </div>

      <div class="column">
        <sc-field label="Método de entrega" prop="delivery_methods">
          <sc-delivery-method-dropdown
            v-model="fields.delivery_methods"
            :logistic-provider-id="fields.logistic_providers"
            @selectAll="(values) => fields.delivery_methods = values"
            @clearFilter="() => fields.delivery_methods = []"
            dropdown />
        </sc-field>
      </div>
    </div>

    <div class="columns is-multiline">
      <div class="column">
        <sc-field label="Data de despacho" prop="date_range">
          <sc-range-date-picker v-model="fields.date_range" :format="formatDate"/>
        </sc-field>
      </div>

      <div class="column">
        <sc-field label="Status" prop="status">
          <sc-multiple-selection
            v-model="fields.status"
            :options="enumStatus"
            @clearFilter="() => fields.status = []"
            @selectAll="(values) => fields.status = values" />
        </sc-field>
      </div>

      <div class="column">
        <sc-field label="Buscar por" prop="search_by">
          <sc-select v-model="fields.search_by" expanded>
            <option selected value="order_number">Pedido</option>
            <option value="invoice_number">Nota Fiscal</option>
          </sc-select>
        </sc-field>
      </div>

      <div v-if="fields.search_by === 'order_number'" class="column">
        <sc-field label="Pedido" prop="search_values">
          <sc-taginput
            v-model="fields.search_values"
            placeholder="Informe um ou mais pedidos"
            :on-paste-separators="[',', ' ']"
            :maxtags="500" />
        </sc-field>
      </div>

      <div v-if="fields.search_by === 'invoice_number'" class="column">
        <sc-field label="Nota Fiscal" prop="search_values">
          <sc-taginput
            v-model="fields.search_values"
            placeholder="Informe um ou mais NFs"
            :on-paste-separators="[',', ' ']"
            :maxtags="500" />
        </sc-field>
      </div>
    </div>

    <div class="sc-form__footer columns page-pre-invoice-audit-form__footer">
      <div class="column">
        <div class="buttons is-right">
          <sc-button
            type="button"
            text="Limpar filtros"
            @click="$emit('clearFilters')" />

          <sc-button
            type="submit"
            theme="primary"
            text="Buscar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    ScButton,
    ScField,
    ScInput,
    ScDeliveryMethodDropdown,
    ScIcon,
    ScLogisticProviderDropdown,
    ScMultipleSelection,
    ScRangeDatePicker,
    ScSelect,
    ScTaginput,
    ScTooltip,
    ScWarehouseDropdown,
  } from '@intelipost-js/secure-components';
  import Moment from '@intelipost-js/secure-providers';
  import EnumStatus from '../../enums/EnumStatus';

  export default {
    name: 'sc-pre-invoice-audit-form',
    props: {
      fields: {
        type: [Object, null],
        required: true,
      },
      isValid: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      enumStatus() {
        return EnumStatus;
      },
    },
    methods: {
      formatDate(date_range) {
        return {
          start: Moment(date_range.start).format('YYYY-MM-DD'),
          end: Moment(date_range.end).format('YYYY-MM-DD'),
        };
      },
    },
    components: {
      ScButton,
      ScField,
      ScInput,
      ScDeliveryMethodDropdown,
      ScIcon,
      ScLogisticProviderDropdown,
      ScMultipleSelection,
      ScRangeDatePicker,
      ScSelect,
      ScTaginput,
      ScTooltip,
      ScWarehouseDropdown,
    },
  };
</script>

<style lang="scss" scoped>
.page-pre-invoice-audit-form {
  &__footer {
    &.sc-form__footer {
      background-color: whitesmoke;
      border-top: 1px solid #e7e7e7;
      margin: 1.25rem -1.25rem -1.25rem -1.25rem;
      padding: 0.5rem;
      border-radius: 0 0 5px 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-audit/components/sc-pre-invoice-audit-form/ScPreInvoiceAuditForm.vue